export default "__VITE_ASSET__BCvM6J0L__"